// extracted by mini-css-extract-plugin
module.exports = {"modal":"_3WZdr","container":"_3a8P1","header":"_3Li_U","title":"_2rFxe","content":"_1qsfR","text":"_2a2JC","submit":"_1-R_1","btnSubmit":"_3cXOZ"};